<!--  -->
<template>
  <v-container fluid class="pa-0">
    <v-row id="loading-indicator" class="text-center" justify="center" v-if="loading">
      <v-col class="text-h6" v-if="title">
        {{ title }}
      </v-col>
      <v-col class="loader">
        <v-progress-circular indeterminate :size="size" :width="width" :color="color" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LoadingIndicator',
  props: {
    color: {
      type: String,
      default: '#063562',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 70,
    },
    title: {
      type: String,
      default: null,
    },
    width: {
      type: Number,
      default: 7,
    },
  },
});
</script>

<style lang="scss">
#loading-indicator {
  width: 100%;
  height: 100%;
  z-index: 10;
  position: absolute;
  background: rgba(255, 255, 255, 1);
  backdrop-filter: blur(7000px);
}
</style>
